import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { environment } from 'environments/environment';
import { MatSidenav } from '@angular/material/sidenav';
import { Options } from 'angular2-notifications';

interface ExternalLink   {
  url: string,
  routerLink?: never
}
interface InternalLink {
  routerLink: string[],
  url?: never,
}

type BaseLink = ExternalLink | InternalLink

type BaseNavItem = BaseLink & {
  type: string;
  text: string;
  description?: string;
}

export type NavItem = Omit<BaseNavItem, 'description'>  & {
  dropdownItems?: BaseNavItem[]
}

@Component({
  selector: 'external-content-wrapper',
  templateUrl: './external-content-wrapper.component.html',
  styleUrls: ['./external-content-wrapper.component.scss']
})
export class ExternalContentWrapperComponent implements OnInit {
  @ViewChild('snav') sidenav: MatSidenav;

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: (resize: MediaQueryListEvent) => void

  notificationsOptions: Options = {
    showProgressBar: false,
    position: ['top', 'right'],
    clickToClose: true,
    lastOnBottom: false,
    timeOut: 2500,
    icons: {
      alert: '',
      info: '',
      warn: '',
      success: '',
      error: ''
    }
  }

  HEADER_HEIGHT = 55; // same as css variable

  navItems : NavItem[] = [
    { type:'dropdown', text: 'Buyer', url: 'https://houwzer.com/buyer' , dropdownItems: [
        { type:'external', text: 'Buy', description: 'Buy without added pressure', url: 'https://houwzer.com/buy' },
        { type:'external', text: 'Cash Advantage', description: 'Win the bidding war with cash', url: 'https://houwzer.com/cash-advantage' }
      ]
    },
    { type:'dropdown', text: 'Seller', url: 'https://houwzer.com/seller' , dropdownItems: [
        { type:'external', text: 'Sell', description: 'Save thousands selling your home', url: 'https://houwzer.com/sell' },
        { type:'external', text: 'Convenience Offer', description: 'Get a backup offer', url: 'https://houwzer.com/convenience-offer' }
      ]
    },
    { type:'dropdown', text: 'Bundler', url: 'https://houwzer.com/bundler' , dropdownItems: [
        { type:'external', text: 'Sell First', description: 'Maximize every dollar by selling first', url: 'https://houwzer.com/bundle' },
        { type:'external', text: 'Buy Before You Sell', description: 'Land your next home first with cash', url: 'https://houwzer.com/buy-before-you-sell' }
      ]
    },
    { type:'dropdown', text: 'Mortgage', url: 'https://houwzer.com/mortgage',  dropdownItems: [
        { type:'external', text: 'Purchase', description: 'Get the best deal on your new home', url: 'https://houwzer.com/purchase' },
        { type:'external', text: 'Refinance', description: 'Refinance with better terms', url: 'https://houwzer.com/refinance' }
      ]
    },
    { type:'external', text: 'Reviews', url: 'https://houwzer.com/reviews' },
    { type:'internal', text: 'Our Homes', routerLink: ['/our-homes'] },
    { type:'dropdown', text: 'About', url: 'https://houwzer.com/about', dropdownItems: [
        { type:'external', text: 'Our Agents',   url: 'https://houwzer.com/our-agents' },
        { type:'external', text: 'Our Values',  url: 'https://houwzer.com/about/our-values' },
        { type:'external', text: 'Careers',  url: 'https://houwzer.com/careers' },
        { type:'external', text: 'Contact',  url: 'https://houwzer.com/contact' }
      ]
    },
  ]

  hostName = environment.hostName;

  constructor(
    private media: MediaMatcher,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    // 991 is the highest bootstrap medium size and sould be everything but "desktop"
    this.mobileQuery = this.media.matchMedia('(max-width: 991px)');
    this._mobileQueryListener = (resize: MediaQueryListEvent) => {
      // close sidenav if switched to desktop
      if(!resize.matches) {
        this.sidenav.close();
      }

      this.changeDetectorRef.detectChanges()
    };

    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
}
